import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const bannerBase = style({
  display: "flex",
  alignItems: "flex-start",
  gap: primitiveTokens.sizing["3x"],
  padding: `${primitiveTokens.sizing["2x"]} ${primitiveTokens.sizing["4x"]}`,
  borderRadius: primitiveTokens.radii.md,
  background: semanticThemeTokens.note.info.backgroundColor,
  color: semanticThemeTokens.note.info.textColor,
  margin: `${primitiveTokens.sizing["2x"]} 0`
});

export const bannerBody = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"],
  flex: 1,
  minWidth: 0
});

export const bannerTitle = style({
  fontSize: primitiveTokens.type.sm,
  fontWeight: 600,
  margin: 0
});

export const bannerNotes = style({
  margin: 0,
  paddingLeft: primitiveTokens.sizing["5x"],
  fontSize: primitiveTokens.type.xs,
  display: "flex",
  flexDirection: "column",
  gap: "2px"
});
